"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTableSchema = exports.isAnalyzer = void 0;
const validation_1 = require("../validator/validation");
const isStandardAnalyzer = (0, validation_1.isLiteral)('standard');
const isWhitespaceAnalyzer = (0, validation_1.isLiteral)('whitespace');
const isCharNGramAnalyzer = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('char-ngram'),
    minGram: validation_1.isNumber,
    maxGram: validation_1.isNumber,
});
const isDelimiterAnalyzer = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('delimiter'),
    delimiter: validation_1.isString,
    trimWhitespace: validation_1.isBoolean,
});
const isSupportedLanguage = (0, validation_1.isLiteral)('arabic', 'ar', 'armenian', 'hy', 'basque', 'eu', 'brazilian', 'pt-br', 'bulgarian', 'bg', 'catalan', 'ca', 'cjk', 'czech', 'cs', 'danish', 'da', 'dutch', 'nl', 'english', 'en', 'finnish', 'fi', 'french', 'fr', 'galician', 'gl', 'german', 'de', 'greek', 'el', 'hindi', 'hi', 'hungarian', 'hu', 'indonesian', 'id', 'irish', 'ga', 'italian', 'it', 'latvian', 'lv', 'norwegian', 'no', 'persian', 'fa', 'portuguese', 'pt', 'romanian', 'ro', 'russian', 'ru', 'spanish', 'es', 'swedish', 'sv', 'thai', 'th', 'turkish', 'tr');
const isLanguageAnalyzer = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('language'),
    language: isSupportedLanguage,
    useDefaultStopWords: validation_1.isBoolean,
    customStopWords: (0, validation_1.isArrayOf)(validation_1.isString).or(validation_1.isUndefined),
    customKeyWords: (0, validation_1.isArrayOf)(validation_1.isString).or(validation_1.isUndefined),
});
const isTokenNGramAnalyzer = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('token-ngram'),
    source: (0, validation_1.fromLazy)(() => exports.isAnalyzer),
    minGram: validation_1.isNumber,
    maxGram: validation_1.isNumber,
    tokenSeparator: validation_1.isString,
});
exports.isAnalyzer = (0, validation_1.isSomeOf)(isStandardAnalyzer, isWhitespaceAnalyzer, isCharNGramAnalyzer, isDelimiterAnalyzer, isLanguageAnalyzer, isTokenNGramAnalyzer);
const isBooleanColumn = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('Boolean'),
    nullable: (0, validation_1.isSomeOf)(validation_1.isBoolean, validation_1.isUndefined),
    link: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isUndefined),
});
const isIntColumn = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('Int'),
    nullable: (0, validation_1.isSomeOf)(validation_1.isBoolean, validation_1.isUndefined),
    link: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isUndefined),
});
const isLongColumn = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('Long'),
    nullable: (0, validation_1.isSomeOf)(validation_1.isBoolean, validation_1.isUndefined),
    link: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isUndefined),
});
const isDecimalColumn = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('Decimal'),
    nullable: (0, validation_1.isSomeOf)(validation_1.isBoolean, validation_1.isUndefined),
    link: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isUndefined),
});
const isStringColumn = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('String'),
    nullable: (0, validation_1.isSomeOf)(validation_1.isBoolean, validation_1.isUndefined),
    link: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isUndefined),
});
const isTextColumn = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('Text'),
    nullable: (0, validation_1.isSomeOf)(validation_1.isBoolean, validation_1.isUndefined),
    link: (0, validation_1.isSomeOf)(validation_1.isString, validation_1.isUndefined),
    analyzer: exports.isAnalyzer,
});
const isColumnSchema = (0, validation_1.isSomeOf)(isBooleanColumn, isIntColumn, isLongColumn, isDecimalColumn, isStringColumn, isTextColumn);
exports.isTableSchema = (0, validation_1.isObjectOf)({
    type: (0, validation_1.isLiteral)('table'),
    columns: (0, validation_1.isMapOf)(isColumnSchema),
});
//# sourceMappingURL=aito.js.map